import m from 'mithril'
import type { Review } from '../../shared/types.ts'
import { Stars, timeAgo } from '../ui.ts'

export const ReviewCard: m.Component<{ review: Review; hideAuthor?: boolean; hidePlace?: boolean }> = {
  view: ({ attrs }) => {
    const { review } = attrs
    return m('article.card.review', [
      m('header.review-head', [
        attrs.hideAuthor
          ? null
          : m(
              m.route.Link,
              { href: `/u/${review.author.username}`, class: 'review-author' },
              review.author.displayName,
            ),
        m('time.muted', { datetime: review.updatedAt }, timeAgo(review.updatedAt)),
      ]),
      attrs.hidePlace
        ? null
        : m(m.route.Link, { href: `/r/${review.restaurant.ref}`, class: 'review-place' }, [
            m('span.place-name', review.restaurant.name),
            review.restaurant.city ? m('span.muted', ` ${review.restaurant.city}`) : null,
          ]),
      m('div.review-meta', [
        m(Stars, { value: review.rating }),
        review.visitedOn ? m('span.muted', `visited ${review.visitedOn}`) : null,
      ]),
      review.body ? m('p.review-body', review.body) : null,
    ])
  },
}
